/* Maison Lumelle — sticky bars via CLASS toggle.
   rAF-driven so it works no matter which element scrolls (window or an inner container).
   Toggling a class is idempotent, so the CSS transition fires once per state change (no fighting). */
(function () {
  'use strict';
  function frame() {
    var comp = document.querySelector('.lumelle-header-compact');
    var header = document.querySelector('.lumelle-header');
    if (comp && header) comp.classList.toggle('lm-stuck', header.getBoundingClientRect().bottom <= 0);

    var sticky = document.querySelector('.lumelle-stickybar');
    var atc = document.querySelector('.lumelle-atc');
    if (sticky && atc) sticky.classList.toggle('lm-stuck', atc.getBoundingClientRect().bottom < 0);

    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();
